import { render, staticRenderFns } from "./qyxxbgLookDia.vue?vue&type=template&id=68083419&scoped=true&"
import script from "./qyxxbgLookDia.vue?vue&type=script&lang=js&"
export * from "./qyxxbgLookDia.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbgLookDia.vue?vue&type=style&index=0&id=68083419&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68083419",
  null
  
)

export default component.exports